<template>
  <div>
    <confirm-box :dialog="dialog" @confirmed="deletePatient" @cancel="cancel" />
    <v-data-table
      :headers="headers"
      :items="delagatedPersons"
      :loading="loading"
      :items-per-page="itemsPerPage"
      @page-count="pageCount = $event"
      :page.sync="page"
      item-key="id"
      hide-default-footer
      hide-default-header
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Delagated Person</v-toolbar-title>
          <v-divider class="mx-4 " inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn
            @click="viewCreate"
            color="teal accent-4"
            depressed
            dark
            class="mb-1"
          >
            <v-icon left dark>
              mdi-plus-circle-outline
            </v-icon>
            New Item
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:header="{ props: { headers } }">
        <thead class="header">
          <tr>
            <th
              v-for="header in headers"
              :key="header.text"
              class="header--text"
            >
              {{ header.text }}
            </th>
          </tr>
        </thead>
      </template>

      <template v-slot:item="{ index, item }">
        <tr>
          <td>{{ index + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.age }}</td>
          <td>{{ item.sex == 1 ? "Male" : "Female" }}</td>
          <td>{{ item.relationship == 1 ? "Family" : "Friends" }}</td>
          <td @click="viewSignDialog(item)" v-if="item.signature">
            <img width="80" height="80" :src="item.signature" />
          </td>
          <td>
            <div class="mr-2">
              <v-btn
                @click="goUpdateForm(item)"
                icon
                color="orange darken-1"
                class="mr-2 white--text"
                depressed
              >
                <v-icon>
                  mdi-pencil-outline
                </v-icon>
              </v-btn>
              <v-btn
                @click="openConfrimBox(item)"
                icon
                color="red lighten-1"
                class="white--text"
                depressed
              >
                <v-icon>
                  mdi-delete-outline
                </v-icon>
              </v-btn>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="text-center py-3">
      <v-pagination
        color="purple accent-4"
        v-model="page"
        :length="pageCount"
      ></v-pagination>
    </div>

    <sign-dialog
      :enrollEachData="signature"
      :dialog="signDialog"
      @cancel="close"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import ConfirmBox from "@/components/notification/ConfirmBox";
import SignDialog from "@/components/patient/enroll/modal/SignDialog";

export default {
  props: {
    delagatedPersons: {
      type: Array,
    },
    patient_id: {
      type: String,
    },
  },
  components: {
    ConfirmBox,
    SignDialog,
  },
  data: () => ({
    pageCount: 0,
    page: 1,
    itemsPerPage: 10,
    item: {},
    dialog: false,
    signDialog: false,
    signature: {},
    headers: [
      { text: "No", value: "no" },
      { text: "Name", value: "name" },
      { text: "Age", value: "age" },
      { text: "Sex", value: "sex" },
      { text: "Relationship", value: "relationship" },

      { text: "Actions", value: "actions" },
    ],
  }),
  computed: {
    ...mapState("Loading", ["loading"]),
  },
  methods: {
    viewCreate() {
      this.$router.push(`/create/delagated-person/${this.patient_id}`);
    },
    viewSignDialog(item) {
      this.signDialog = !this.signDialog;
      this.signature = item;
    },
    openConfrimBox(item) {
      this.item = item;
      this.dialog = !this.dialog;
    },
    deletePatient() {
      let data = {
        id: this.item.id,
      };
      this.$store
        .dispatch("DelPerson/delete", data)
        .then(() => (this.dialog = !this.dialog));
    },
    cancel() {
      this.dialog = !this.dialog;
    },
    close() {
      this.signDialog = !this.signDialog;
    },
    goUpdateForm(item) {
      let convertNumber = parseInt(item.id);
      this.$router.push({
        name: "edit-delagated-person",
        params: {
          patient_id: convertNumber,
        },
      });
    },
  },
};
</script>

<style scoped></style>
